import moment, { MomentInput, MomentFormatSpecification } from 'moment';

export const compareDates = ({
  date,
  dateCompareTo,
  dateInputFormat,
  unitOfTime = 'ms',
}: {
  date: MomentInput;
  dateCompareTo: MomentInput;
  dateInputFormat?: MomentFormatSpecification;
  unitOfTime?: moment.unitOfTime.Diff;
}): number => {
  const dateInMoment = moment(date, dateInputFormat);
  const dateCompareToInMoment = moment(dateCompareTo, dateInputFormat);

  return dateInMoment.diff(dateCompareToInMoment, unitOfTime);
};

export const getDuration = ({
  start,
  end,
  breakInMinutes,
}: {
  start: MomentInput;
  end: MomentInput;
  breakInMinutes?: number;
}) => {
  const duration = moment.duration(moment(end).diff(moment(start)));
  const hours = Math.floor(duration.hours());
  const minutes = Math.floor(duration.minutes() % 60);
  const timeDifference = breakInMinutes
    ? duration.subtract(breakInMinutes, 'minutes')
    : null;
  const timeDifferenceHours = timeDifference
    ? Math.floor(timeDifference.asHours())
    : null;
  const timeDifferenceMinutes = timeDifference
    ? Math.floor(timeDifference.asMinutes() % 60)
    : null;
  return {
    duration,
    hours,
    minutes,
    timeDifference,
    timeDifferenceHours,
    timeDifferenceMinutes,
  };
};
